const skills = [
    {
        category: "development",
        details: [
            {
                name: "Python(Django/Flask)",
                levelPercent: 100
            },
            {
                name: "JavaScript/TypeScript",
                levelPercent: 100
            },
            {
                name: "JSON/XML",
                levelPercent: 100
            },
            {
                name: "Git",
                levelPercent: 80
            },
            {
                name: "Bash",
                levelPercent: 80
            },
            {
                name: "Postgres",
                levelPercent: 80
            },
            {
                name: "MySQL",
                levelPercent: 80
            },
            {
                name: "Docker",
                levelPercent: 60
            },
            {
                name: "GraphQl",
                levelPercent: 60
            },
            {
                name: "Golang",
                levelPercent: 60
            },
            {
                name: "C/C++",
                levelPercent: 20
            },
            {
                name: "Machine Learning",
                levelPercent: 20
            },
        ]
    },
    {
        category: "cloud",
        details: [
            {
                name: "GCP",
                levelPercent: 80
            },
            {
                name: "AWS",
                levelPercent: 40
            }
        ]
    },
    {
        category: "devops",
        details: [
            {
                name: "Github",
                levelPercent: 100
            },
            {
                name: "Bitbucket",
                levelPercent: 100,
            },
            {
                name: "Travis",
                levelPercent: 100
            },
            {
                name: "CI/CD",
                levelPercent: 80
            },
            {
                name: "Circle-CI",
                levelPercent: 60
            }
        ]
    }
]

export default skills;
